var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5, _line6, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2b337;}.cls-2{fill:none;stroke:#231f20;stroke-miterlimit:10;stroke-width:.75px;}.cls-3{fill:#fff;}.cls-4{fill:#2f3e4a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.16,46c0-23.29-18.88-42.16-42.16-42.16S3.84,22.71,3.84,46s18.87,42.16,42.16,42.16,42.16-18.88,42.16-42.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46,4.22C22.96,4.22,4.22,22.96,4.22,46s18.74,41.78,41.78,41.78,41.78-18.74,41.78-41.78S69.04,4.22,46,4.22M46,88.54c-23.46,0-42.54-19.09-42.54-42.54S22.54,3.46,46,3.46s42.54,19.09,42.54,42.54-19.09,42.54-42.54,42.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.44,74.7c-.77.76-1.8,1.23-2.94,1.23h-1.07c-.6,0-1.16-.13-1.68-.35-.05-.01-.08-.06-.16-.07-1.34-.65-2.25-2.05-2.25-3.65v-.41h9.27v.41c0,1.11-.45,2.11-1.17,2.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.33,71.45h-1.05c-1.51,0-2.72-1.22-2.72-2.72v-7.1h16.8v7.1c0,1.51-1.22,2.72-2.72,2.72h-10.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.37,61.62h-16.8v.02c-.68-1.54-1.43-2.95-2.56-4.22-1.19-1.43-2.45-2.92-3.69-4.28-3.27-3.75-5.33-8.97-5.33-14.66,0-.84.04-1.66.13-2.48.36-3.65,1.56-7.14,3.69-10.01,3.16-4.22,7.5-6.68,12.08-7.56,3.3-.65,6.75-.43,9.97.52,7.02,2.11,12.96,7.98,14,17.05.1.81.14,1.63.17,2.48.08,5.69-2.06,10.91-5.4,14.66-1.24,1.36-2.48,2.84-3.66,4.28-1.07,1.27-1.92,2.69-2.58,4.22h-.01v-.02ZM55.39,28.54c.48-4.15-2.64-6.15-5.39-6.15-2.21.01-3.99,1.9-3.99,4.24,0-2.34-1.8-4.23-3.99-4.24-2.76,0-5.88,2-5.41,6.15-.18-.02-3.82-.34-5.28,3.52-.52,1.36-.01,3.79.57,4.45h0c-1.07.48-1.82,1.59-1.82,2.91s.74,2.39,1.77,2.86h.01c-.37.77-.74,1.66-.61,2.71.33,2.66,1.89,3.69,3.41,4.03h.01c-.04.19-.06.41-.06.63,0,1.68,1.29,3.05,2.87,3.05.19,0,.36-.02.54-.06.72,1.81,2.44,2.62,4.09,2.62.14,0,.3-.01.45-.02,1.9-.17,3.46-1.65,3.46-3.68,0,2.03,1.54,3.51,3.45,3.68,1.78.16,3.74-.63,4.52-2.59h.01c.18.04.34.06.53.06,1.58,0,2.88-1.37,2.88-3.05,0-.22-.02-.43-.06-.63,1.53-.34,3.1-1.36,3.41-4.03.13-1.05-.23-1.94-.6-2.7h0c1.05-.48,1.78-1.59,1.78-2.87s-.75-2.42-1.82-2.89h0c.58-.68,1.08-3.1.57-4.46-1.47-3.86-5.1-3.54-5.29-3.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.61,28.54c-.47-4.15,2.65-6.15,5.41-6.15,2.19.01,3.99,1.9,3.99,4.24v24.91c0,2.03-1.56,3.51-3.46,3.68-.14.01-.3.02-.45.02-1.65,0-3.36-.81-4.09-2.62-.18.04-.35.06-.54.06-1.58,0-2.87-1.37-2.87-3.05,0-.22.02-.43.06-.63h-.01c-1.52-.34-3.09-1.36-3.41-4.03-.12-1.05.24-1.94.61-2.7h-.01c-1.04-.48-1.77-1.59-1.77-2.87s.75-2.42,1.82-2.89h0c-.58-.68-1.08-3.1-.57-4.46,1.46-3.86,5.1-3.54,5.28-3.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,22.4c2.75,0,5.87,2,5.39,6.15.19-.02,3.82-.34,5.29,3.52.52,1.36.01,3.79-.57,4.45h0c1.07.48,1.82,1.59,1.82,2.91s-.74,2.39-1.78,2.86h0c.37.77.74,1.66.6,2.71-.31,2.66-1.88,3.69-3.41,4.03.04.19.06.41.06.63,0,1.68-1.3,3.05-2.88,3.05-.19,0-.35-.02-.53-.06h-.01c-.78,1.96-2.74,2.75-4.52,2.59-1.9-.17-3.45-1.65-3.45-3.68v-24.91c0-2.34,1.78-4.23,3.99-4.24Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20.95,
    y1: 24.98,
    x2: 24.53,
    y2: 26.96
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.07,
    y1: 38.84,
    x2: 21.2,
    y2: 38.84
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20.95,
    y1: 52.67,
    x2: 24.53,
    y2: 50.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.06,
    y1: 52.67,
    x2: 67.49,
    y2: 50.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 74.93,
    y1: 38.84,
    x2: 70.81,
    y2: 38.84
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.06,
    y1: 24.98,
    x2: 67.49,
    y2: 26.96
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.38,61.65c.66-1.53,1.51-2.95,2.58-4.22,1.18-1.43,2.42-2.92,3.66-4.28,3.34-3.75,5.48-8.97,5.4-14.66-.02-.86-.07-1.68-.17-2.48-1.04-9.07-6.98-14.94-14-17.05-3.22-.95-6.67-1.17-9.97-.52-4.58.88-8.92,3.34-12.08,7.56-2.13,2.87-3.33,6.35-3.69,10.01-.1.82-.13,1.64-.13,2.48,0,5.69,2.06,10.91,5.33,14.66,1.24,1.36,2.5,2.84,3.69,4.28,1.12,1.27,1.88,2.68,2.56,4.22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.37,61.65v-.02h-16.8v7.1c0,1.51,1.22,2.72,2.72,2.72h11.36c1.51,0,2.72-1.22,2.72-2.72v-7.08Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.6,71.45v.41c0,1.11-.45,2.11-1.17,2.84-.77.76-1.8,1.23-2.94,1.23h-1.07c-.6,0-1.16-.13-1.68-.35-.05-.01-.08-.06-.16-.07-1.34-.65-2.25-2.05-2.25-3.65v-.41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.15,42.27s-1.07-1.15-3.45-1.45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.12,36.51s-1.59-.29-2.71-.06"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.37,28.58s-.82.25-1.66,1.59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.34,49.01s-1.3-1.83-2.48-2.13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.99,52.63s-.98-2.25-2.18-2.58"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.01,26.64c0-2.34,1.78-4.23,3.99-4.24,2.75,0,5.87,2,5.39,6.15.19-.02,3.82-.34,5.29,3.52.52,1.36.01,3.79-.57,4.45h0c1.07.48,1.82,1.59,1.82,2.91s-.74,2.39-1.78,2.86h0c.37.77.74,1.66.6,2.71-.31,2.66-1.88,3.69-3.41,4.03.04.19.06.41.06.63,0,1.68-1.3,3.05-2.88,3.05-.19,0-.35-.02-.53-.06h-.01c-.78,1.96-2.74,2.75-4.52,2.59-1.9-.17-3.45-1.65-3.45-3.68"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.82,34.05s.17,2.24,2.5,1.74"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.45,39.79s-1.68,2.52-4.16,2.03"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.93,45.76s.19.35.61.64c.42.28,1.07.47,2,.18"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.63,48.69s-.35-.98.66-1.89"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.58,34.49s-.35-.99.66-1.9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.47,27.88s2.12-.3,2.66-2.12"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.85,42.27s1.08-1.15,3.46-1.45"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.9,36.51s1.59-.29,2.71-.06"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.63,28.58s.83.25,1.68,1.59"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.66,49.01s1.3-1.83,2.48-2.13"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.02,52.63s.96-2.25,2.18-2.58"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.01,51.54v-24.91c0-2.34-1.8-4.23-3.99-4.24-2.76,0-5.88,2-5.41,6.15-.18-.02-3.82-.34-5.28,3.52-.52,1.36-.01,3.79.57,4.45h0c-1.07.48-1.82,1.59-1.82,2.91s.74,2.39,1.77,2.86h.01c-.37.77-.74,1.66-.61,2.71.33,2.66,1.89,3.69,3.41,4.03h.01c-.04.19-.06.41-.06.63,0,1.68,1.29,3.05,2.87,3.05.19,0,.36-.02.54-.06.72,1.81,2.44,2.62,4.09,2.62.14,0,.3-.01.45-.02,1.9-.17,3.46-1.65,3.46-3.68Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.18,34.05s-.16,2.24-2.48,1.74"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.56,39.79s1.68,2.52,4.16,2.03"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.08,45.76s-.19.35-.61.64c-.42.28-1.08.47-2.01.18"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.37,48.69s.35-.98-.65-1.89"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.43,34.49s.34-.99-.66-1.9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.53,27.88s-2.12-.3-2.65-2.12"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.74,
    y1: 68.28,
    x2: 51.17,
    y2: 68.28
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.74,
    y1: 65.14,
    x2: 51.17,
    y2: 65.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.81ea99e09f391df89a178ceab2da188b.svg";
export { ForwardRef as ReactComponent };